module.exports = __webpack_public_path__ + "static/img/i2.912d66d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/i2.png
// module id = vAB3
// module chunks = 3